import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export function getDateFromNgbDate(ngbDate?: NgbDate) {
    if (ngbDate) {
        return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    }
    else return undefined;
}

export function getNgbDate(range?: number | undefined): NgbDate | any {
    let year: number = new Date().getFullYear() + (range ?? 0);
    let month: number = new Date().getMonth() + 1;
    let day: number = new Date().getDate();
    return new NgbDate(year, month, day);
}

export function adjustForTimezone(date: Date): Date {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
    timeOffsetInMS = timeOffsetInMS < 0 ? -timeOffsetInMS : timeOffsetInMS;
    date.setTime(date.getTime() + timeOffsetInMS);
    return date
}

export function hoursFromDate(date: Date | number, activeLang: string): string | undefined {
    return new Date(date).toLocaleTimeString(activeLang, {
        hour: '2-digit',
        minute: '2-digit',
    }).split(" ").at(0)
}
